import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

function TicketMenu({ openItem = null, activeItem = null }) {
  return (
    <li
      className={`nav-item has-treeview 
      ${sidebarHelper.checkOpenItem(openItem, "tickets")} `}
    >
      <a
        href="# "
        className={`nav-link  
      ${sidebarHelper.checkActiveItem(openItem, "tickets")} `}
      >
        <i className="nav-icon hl-messages"></i>
        <p>
          راهنما و پشتیبانی
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/tickets"
            className={`nav-link  
          ${sidebarHelper.checkActiveItem(activeItem, "all-user-tickets")} `}
          >
            <i className="hl-microphone nav-icon"></i>
            <p> درخواست پشتیبانی</p>{" "}
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/help"
            className={`nav-link  
          ${sidebarHelper.checkActiveItem(activeItem, "help")} `}
          >
            <i className="hl-message-help nav-icon"></i>
            <p> راهنما </p>{" "}
          </Link>
        </li>
      </ul>
    </li>
  );
}

export default TicketMenu;
